import ThankYouGuest from './ThankYouGuest';

export default ThankYouGuest;
